import { ActivityProgress, ActivityType, MinimalActivity } from './activity';
import { Communication } from './course-communication';
import { User } from './my-account';
import { PointsConfiguration } from './points-configuration';

export interface MinimalAiRolePlay extends MinimalActivity {
  type: ActivityType.AI_ROLE_PLAY;
}
type ObjectionType = { id: number; text: string };

export interface AiRolePlay extends MinimalAiRolePlay {
  pointsConfiguration?: PointsConfiguration;
  isTodo: boolean;
  expirationDate: string | null;
  hardDeadline: boolean;
  hasCompletedSubmissions: boolean;
  progress: ActivityProgress;
  pointsReceived: number;
  communicationsCount?: number;
  communications: Communication[];
  catalogId: string;
  courseCatalogId: string,
  courseId: number;
  lecturePageId: number;
  lectureComponentId: number;
  description?: string;
  context: string;
  learnerRole: string;
  aiCharacterRole: string;
  aiCharacterName: string;
  aiCharacterPersonality: string;
  aiCharacterObjections: ObjectionType[];
  aiLearnerGoals: ObjectionType[];
  learnerRoleBrief: string;
  situationContextBrief: string;
  goalsBrief: string;
}

export enum Evaluation {
  NEED_WORK = 'needs_work',
  GOOD_JOB = 'good_job',
  EXCELLENT = 'excellent',
}

export type AiRolePlayFeedback = {
  evaluation: Evaluation;
  overallSummary: string;
  whereYouDidWell: string[];
  whereYouCanGrow: string[];
};

export type AiRolePlaySubmission = {
  id: number;
  status: string;
  attemptNumber: number;
  finishedAt: string;
  createdAt: string;
  updatedAt: string;
  openingNarrative: string;
  leaderboardRank: number;
  leaderboardPoints: number;
  priorLeaderboardRank: number;
  feedback: AiRolePlayFeedback | null;
  closingReason?: string;
  user?: User;
  aiRolePlay: {
    id: number;
    title?: string;
    progress?: ActivityProgress;
    pointsConfiguration?: {
      id: number;
      activityId: number;
      activityType: string;
      points: number;
      pointsReceived: number;
    },
    isRequiredForCompletion?: boolean;
    expirationDate?: string;
  },
};

export interface AiRolePlayNormalized
  extends Omit<AiRolePlay, 'pointsConfiguration' | 'communications'> {
  pointsConfigurationId?: number;
  vieweeSubmissionId?: number;
  communications: number[];
  learnerStartedSubmission: boolean;
  submissionId?: number;
}

export interface AiRolePlaysNormalized {
  [id: string]: AiRolePlayNormalized;
}

export interface AiRolePlaySubmissionsNormalized {
  [id: string]: AiRolePlaySubmission;
}
